// Per-field fixed unit lists. These are presented to users via UnitSelector
// instead of the previous dynamic-add behaviour. Lists are aligned with the
// units that NPA Step 1 / Step 2 conversion logic recognises — adding a custom
// unit here would silently break those calculations.

export const EQUIPMENT_CONTACT_AREA_UNITS = Object.freeze(['cm²', 'in²']);
export const EQUIPMENT_MATERIAL_AREA_UNITS = Object.freeze(['cm²', 'in²']);

export const PRODUCT_HBEL_UNITS = Object.freeze(['µg/day', 'mg/day', 'g/day']);
export const PRODUCT_MOLECULAR_WEIGHT_UNITS = Object.freeze(['g/mol']);
export const PRODUCT_STRENGTH_UNITS = Object.freeze(['µg', 'mg', 'g', 'g/ml', 'µg/ml', 'mg/ml']);
export const PRODUCT_DOSAGE_UNIT_WEIGHT_UNITS = Object.freeze(['µg', 'mg', 'g', 'mL']);
export const PRODUCT_MDD_UNITS = Object.freeze(['µg', 'mg', 'g', 'g/ml', 'µg/ml', 'mg/ml']);
export const PRODUCT_MQ_UNITS = Object.freeze(['Unit/Dose', 'mL/Dose']);
export const PRODUCT_BATCH_SIZE_UNITS = Object.freeze(['g', 'kg', 'L']);

export const ANALYTICAL_LIMIT_UNITS = Object.freeze(['µg', 'mg', 'g', 'ppm', 'ppb']);

// API registry — compound-level properties. Solubility is one scale in three spellings
// (1 mg/L = 1 ppm ≈ 1 µg/mL in dilute aqueous); the choice is there so the figure can be
// recorded the way the supplier's data sheet states it.
export const API_WATER_SOLUBILITY_UNITS = Object.freeze(['mg/L', 'µg/mL', 'ppm']);
export const API_MDE_UNITS = Object.freeze(['mg/day', 'µg/day', 'g/day']);
